<template>
  <div class="welfare">
    <navigation></navigation>
    <img src="./images/banner.gif" class="welfare-bg"/>
    <div class="welfare-content">
      <div class="welfare-banner">
        <span>即将获得福利</span>
        
        <div class="welfare-card">
          <img class='img' src="./images/icon_fudai@2x.png"/>
          <span>福袋里空空如也，快去参与活动赚取奖励吧！</span>
        </div>
      </div>
      <div class="welfare-benefits">
        <div class="welfare-benefits-title">
          <div>
            <span>我的成就</span>
            <span @click="findQuan">查看我的券包</span>
          </div>
          <div class="welfare-card">
            <img src="./images/icon_chengjiu@2x.png" />
            <span>良好的借还款行为，可以解锁更多精彩成就哟！</span>
          </div>
        </div>
      </div>
      <div class="about-title">关注我们</div>
      <div class="about">
        <img src="../images/img_erweima@2x.png" alt="ct_tmd" id="qrcode" class="qrcode" ref="savePop">
        <div class="column">
          <div class="top">关注公众号：获取更多精彩福利</div>
          <div class="center">1、长按二维码保存至相册</div>
          <div class="bottom">
            <div class="left">2、微信搜索：ct_tmd</div>
            <div class="right" @click="copy">复制</div>
          </div>
        </div>
      </div>
      <div class="footer">
        活动最终解释权归天美贷所有
      </div>
    </div>
    <van-popup
      v-model="protocolPopup"
      class="protocol-popup"
      position="bottom"
    >
      <dl>
        <dt @click="savePhoto">
          保存图片至相册
        </dt>

        <dt @click="closePop">
          取消
        </dt>
      </dl>
    </van-popup>
  </div>
</template>
<script>
import { copyToClipbord } from '../../../assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import { Popup, Toast } from 'vant'
export default {
  name: 'noWelfareIndex',
  data () {
    return {
      protocolPopup: false
    } 
  },
  components: {
    Popup, 
    Toast
  },
  mounted () {
    this.$refs['savePop'].addEventListener('touchstart', this.start)
    this.$refs['savePop'].addEventListener('touchend', this.savePop)
  },
  methods: {
    // 查看我的券包
    findQuan () {
      this.$report({ id: 10189 })
      this.$router.push('/quan/list')
    },
    start () {
      this.time = new Date().getTime()
    },
    savePop () {
      let time = new Date().getTime()
      if (time - this.time > 1000) {
        this.$report({
          id: 10156
        })
        this.protocolPopup = true
      }
    }, 
    closePop () {
      this.protocolPopup = false
    },
    savePhoto () {
      this.$report({
        id: 10157
      })
      this.downloadIamge('http://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/authenticate/1_15683410918_Web_1605512702096', 'qrcode')
      this.protocolPopup = false  
    },

    saveSuccess () {
      this.$report({
        id: 10159
      })
      Toast({
        message: '已保存至系统相册',
        icon: 'http://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/authenticate/1_15683410918_Web_1605509117666',
        duration: 1500
      })
    },

    async downloadIamge (imgsrc, name) {
      if (hasNativeMethod('saveQRCode')) {
        const res = await jsBridge('saveQRCode', {
          url: imgsrc,
          name: name
        })
        if (res && res.code === 'OK') {
          this.saveSuccess()
        }
      } else {
        let image = new Image()
        let self = this
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = function () {
          let canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          let context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)
          let url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
          let a = document.createElement('a') // 生成一个a元素
          let event = new MouseEvent('click') // 创建一个单击事件
          a.download = name // 设置图片名称没有设置则为默认
          a.href = url // 将生成的URL设置为a.href属性
          a.dispatchEvent(event) // 触发a的单击事件
          self.saveSuccess()
        }
        image.src = imgsrc
      }
    },
    copy () {
      this.$report({
        id: 10158
      })
      copyToClipbord('ct_tmd')
      this.$message('已复制到剪贴板')
    }
  }
}
</script>
<style scoped lang="less">
@import "../../../assets/less/mixin.less";

.welfare{
    min-height: 100%;
    .protocol-popup {
        background-color: transparent;
        dl {
            background-color: #fff;
            border-radius: 30px 30px 0px 0px;
            padding-bottom: 80px;
            dt {
                display: flex;
                justify-content: space-between;
                align-items: center;
                justify-content: space-around;
                padding: 0 50px;
                height: 110px;
                font-size: 30px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 42px;
            }
            dd {
                height: 110px;
                padding: 0 40px;
                line-height: 110px;
                font-size:30px;
                border-top: 1px solid #EEEEEE;
            }
        }
    }

    background: #FAFAFA;
    &-bg{
        width: 750px;
        height:340px;
        position: relative;
    }
    &-content{
        position: relative;
        width: 750px;
        background: #FAFAFA;
        padding:82px 40px 46px;
        margin-top:-60px;
        border-radius: 30px 30px 0px 0px;
        .welfare-banner{
        span{
            display: inline-block;
            height: 53px;
            font-size: 38px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 53px;
            margin-bottom: 22px;
        }
    }
     .welfare-card{
        width: 670px;
        height: 240px;
        text-align: center;
        background: #FFFFFF;
        box-shadow: 0px 20px 20px 0px rgba(231, 231, 231, 0.5);
        border-radius: 20px;
        padding:50px 0 37px;
        // margin-bottom:30px;
        img{
            display:block;
            margin:auto;
            width:90px;
            height:90px;
            margin-bottom:35px;
        }
        .img{
            width:70px;
            height:64px;
        }
        span{
            height: 30px;
            text-align: center;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 30px;
        }
    }
        .welfare-benefits{
            margin-top:82px;
            &-title{
                div:nth-child(1){
                display: flex;
                justify-content: space-between;
                margin-bottom: 22px;
                span:nth-child(1){
                    height: 53px;
                    font-size: 38px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 53px;
                }
                span:nth-child(2){
                    height: 37px;
                    font-size: 26px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    line-height: 37px;
                    position: relative;
                    right:40px;
                }
                span:nth-child(2)::after{
                    content:'>';
                    color:rgb(204, 206, 214);
                    width:10px;
                    height:17px;
                    position: absolute;
                    right:-20px;
                    top:-2px;
                }
                }
            }
        }
         .about-title{
                margin-top:82px;
                height: 53px;
                font-size: 38px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 53px;
            }
        .about {
            height: 170px;
            margin-top: 18px;
            padding:20px 0;
            background: #FFFFFF;
            box-shadow: 0px 20px 20px 0px rgba(231, 231, 231, 0.5);
            border-radius: 20px;
            display: flex;
            .qrcode {
                margin-left: 20px;
                width: 140px;
                height: 140px;
            }
            .column {
                margin-left: 20px;
                .top {
                    margin-top:11px;
                    font-size: 26px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                    line-height: 37px;
                }
                .center {
                    margin-top: 16px;
                    font-size: 22px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    line-height: 30px;
                }
                .bottom {
                    margin-top: 6px;
                    font-size: 22px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    line-height: 30px;
                    display: flex;
                    .left {
                        padding-right: 60px;
                    }
                    .right {
                        font-size: 22px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #9FC0D2;
                        line-height: 30px;
                    }
                }
            }
        }
    }

.footer {
    text-align: center;
    padding:52px 0 36px 0;
    height: 30px;
font-size: 22px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #CCCCCC;
line-height: 30px;
  }}
</style>